const ToggleMenu = (target) => {
	$(target).click(function () {
		$(this).toggleClass("open").next("ul").slideToggle();
	});
};

module.exports = ToggleMenu;
